// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:33:37

export default {
  "id": "black-pink-st-patricks-day-concert",
  "slug": "black-pink-st-patricks-day-concert",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/e1316f980aa04d6c949ac398a7ee40a6-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/e1316f980aa04d6c949ac398a7ee40a6/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Black Pink St.Patricks day Concert",
      "description": "Step into the glamorous world of Black Pink St. Patrick’s Day Concert, the ultimate dress-up game! Style your favorite Black Pink members with trendy outfits, accessories, and makeup to make them shine for their St. Patrick’s Day performance. With simple controls and endless creativity, this game is perfect for quick fun or long gaming sessions. ",
      "instructions": "Left Mouse button Click or Tap to Play",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "cutedressup",
        "fashion",
        "girls"
      ]
    },
    "zh-CN": {
      "title": "黑pink圣帕特里克节音乐会",
      "description": "踏入Black Pink圣帕特里克节音乐会这个璀璨的世界，终极装扮游戏！用时尚的服装、配饰和妆容为你的最爱Black Pink成员打造光彩照人的造型，让他们在圣帕特里克节表演中闪耀。操作简单，创意无限，这款游戏非常适合快速娱乐或长时间游戏。",
      "instructions": "左鼠标按钮点击或轻触开始游戏",
      "genres": [
        "装扮"
      ],
      "tags": [
        "可爱装扮",
        "时尚",
        "女孩"
      ]
    },
    "zh-TW": {
      "title": "黑色粉紅聖帕特里克節音樂會",
      "description": "踏入光鮮亮麗的 Black Pink 圣帕特里克節音樂會世界，這是一款至高無上的装扮遊戲！為你最喜愛的 Black Pink 成員選擇時尚的服裝、配件和妝容，讓他們在聖帕特里克節的表演中璀璨奪目。遊戲操作簡單，創意無限，這款遊戲既適合短時間的娛樂，也適合長時間的遊戲體驗。",
      "instructions": "左鍵點擊或觸控以遊玩",
      "genres": [
        "裝扮"
      ],
      "tags": [
        "可愛打扮",
        "時尚",
        "女孩"
      ]
    },
    "zh-HK": {
      "title": "黑pink圣帕特里克節音樂會",
      "description": "步入時尚迷人的 Black Pink St. Patrick’s Day 音樂會世界，最終的裝扮遊戲！為你最喜愛的 Black Pink 成員選擇時尚的服裝、配飾和妝容，讓他們為 St. Patrick’s Day 表演時更加閃耀。操作簡單，創意無限，這款遊戲適合隨時隨地快樂玩，也適合長時間遊戲。",
      "instructions": "左鍵點擊或觸碰以開始遊戲",
      "genres": [
        "扮裝"
      ],
      "tags": [
        "可愛裝扮",
        "時尚",
        "女兒"
      ]
    },
    "ja": {
      "title": "ブラックピンク ステイプリーク・デイ・コンサート",
      "description": "ブラックピンク・サン・パトリックの日コンサートの華やかな世界に踏み込んで、究極のドレスアップゲームを楽しむ！お気に入りのブラックピンクメンバーをトレンディな服装、アクセサリー、メイクでスタイリッシュに装い整え、サン・パトリックの日公演で輝かせるのだ。シンプルな操作と無限のクリエイティビティで、短い楽しみから長いゲームセッションまで、このゲームは完璧です。",
      "instructions": "左マウスボタンクリックまたはタップで遊ぶ",
      "genres": [
        "ドレスアップ"
      ],
      "tags": [
        "カワイイドレスアップ",
        "ファッション",
        "ガールズ"
      ]
    },
    "ko": {
      "title": "블랙핑크 스타patricks데이 콘서트",
      "description": "블랙핑크 스타patricks데이 콘서트의 화려한 세계로 들어가세요! 최상의 드레스업 게임입니다! 트렌드 아웃핏, 액세서리, 메이크업으로 블랙핑크 멤버들의 스타patricks데이 공연을 빛내세요. 간단한 조작과 끝없는 창의성으로, 이 게임은 빠른 재미나 오랜 게임 세션에도 완벽합니다.",
      "instructions": "왼쪽 마우스 버튼 클릭 또는 탭하여 게임 시작",
      "genres": [
        "드레스업"
      ],
      "tags": [
        "쿵따봉의 의상",
        "패션",
        "소녀"
      ]
    },
    "fr": {
      "title": "Concert de la Saint-Patrick en noir et rose",
      "description": "Enfilez-vous dans le monde glamour du concert de la Saint-Patrick’s Day de Black Pink, le jeu de déguisement ultime ! Habillez vos membres préférés de Black Pink avec des tenues tendance, des accessoires et du maquillage pour les faire briller pour leur prestation de la Saint-Patrick’s Day. Avec des commandes simples et une créativité infinie, ce jeu est parfait pour des moments de plaisir rapides ou des sessions de jeu prolongées.",
      "instructions": "Clic gauche de la souris ou tapoter pour jouer",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "cutedressup",
        "mode",
        "filles"
      ]
    }
  }
};
